import { Component, Children } from 'react';
import { connect } from 'react-redux';
import lodash from 'lodash';
import OverviewNavigation from 'institutionalAdmin/containers/Overview/OverviewNavigation';
import tabStyle from 'common/components/Tabs/Tab/Tab.scss';
import styles from 'institutionalAdmin/containers/Overview/Overview.scss';
import {systemPermissionsSelector} from '../../selectors/overview';
import {
    studyFeatureAccess,
    manageEventTypeFeatureAccess,
} from 'common/features/predicates';

const STUDY_CONCEPT = 'studyConcept';
const MANAGE_EVENT_TYPES = 'manageEventTypes';

const tabList = [{
    label: 'Users',
    path: '/admin/users',
    systemPermissions: ['institutionalAdmin'],
}, {
    label: 'Groups',
    path: '/admin/groups',
    systemPermissions: ['institutionalAdmin'],
}, {
    label: 'Role Management',
    path: '/admin/role',
    systemPermissions: ['createStudy'],
}, {
    label: 'Reports',
    path: '/admin/report',
    systemPermissions: ['accessReport'],
},{
    label: 'Data Sources',
    path: '/admin/datasources',
    systemPermissions: ['dataSources'],
},{
    label: 'Event Types',
    path: '/admin/events',
    systemPermissions: ['institutionalAdmin'],
    featureAccess: MANAGE_EVENT_TYPES
},
{
    label: 'Permissions',
    path: '/admin/permissions',
    systemPermissions: ['institutionalAdmin', 'manageStudyPermissions'],
    conceptFlag: STUDY_CONCEPT
}];

export class InstitutionalAdminOverview extends Component {
    componentDidMount() {
        if (!this.props.children) {
            this.selectFirstTab();
        }
    }

    selectFirstTab() {
        const tabLink = this.container.querySelector(`.${tabStyle.tab}`);
        if (tabLink) {
            tabLink.click();
        }
    }

    render() {
        const { children, router, location, institution, permittedTabs } = this.props;
        const renderedChild = children ? Children.only(children) : null;
        
        return (
            <div ref={c => this.container = c} className={styles.overview} data-cy="InstitutionalAdminOverview-render">
                <OverviewNavigation tabs={permittedTabs} router={router} location={location} institution={institution}  />
                <div className={styles.OverviewContainerChild} data-cy="InstitutionalAdminOverview-renderedChild">
                    { renderedChild }
                </div>
            </div>
        );
    }
}

export default connect((state, props) => {
    const institution = lodash.get(state, 'me.institution');
    const systemPermissions = systemPermissionsSelector(state);
    const isStudyConcept = studyFeatureAccess(state);
    const canManageEventTypes = manageEventTypeFeatureAccess(state);
    
    let permittedTabs = lodash.compact(tabList.map(tab => {        
        if(tab.conceptFlag === STUDY_CONCEPT && !isStudyConcept){
            return false;
        } 
        if(tab.featureAccess === MANAGE_EVENT_TYPES && !canManageEventTypes){
            return false;
        } 
        if(lodash.difference(tab.systemPermissions, systemPermissions).length===0){
            return tab;
        }
    })); 

    return{
        institution,
        systemPermissions,
        permittedTabs,
    };
})(InstitutionalAdminOverview);
